import request from "@/utils/request";
import axios from "axios";
import { parseFileResponse } from "../../utils/fileResponse";

const baseURL = "/bluetoothlight/web/router/neewerhome/manage/";

/**
 * 获取二维码列表
 * @param {Object} data 查询参数
 * @param {number} data.pageIndex 页码
 * @param {number} data.pageSize 每页条数，仅支持 10、20、50
 * @param {string} data.qrcode 二维码编号，模糊查询
 * @param {string} data.authCode 认证码，模糊查询
 * @param {string} data.macAddress 设备 MAC，模糊查询
 * @param {string} data.modelName 型号名称，模糊查询
 * @param {number} data.codeStatus 二维码状态：0-未下载，1-未绑定，2-已绑定，3-已失效
 * @param {number} data.uploadDateStart 上传开始日期，Asia/Shanghai 当天零点的毫秒时间戳，包含边界
 * @param {number} data.uploadDateEnd 上传结束日期，Asia/Shanghai 当天零点的毫秒时间戳，包含边界
 * @returns
 */
export function getQrcodeList(data) {
  return request("/matter/page", {
    baseURL,
    method: "post",
    data,
  });
}

/**
 * 导出二维码 Excel 表
 * @param {string} url 导出请求url，在列表导出和上传并下载是不同的 url
 * @param {Object} data 查询参数
 * @param {number[]} data.ids （用于上传并下载）非空的数据库记录 ID 列表；元素不能为空且必须大于 0
 * @param {string} data.qrcode 二维码编号
 * @param {string} data.authCode 认证码
 * @param {string} data.macAddress 设备 MAC
 * @param {string} data.modelName 型号名称
 * @param {number} data.codeStatus 二维码状态：0-未下载，1-未绑定，2-已绑定，3-已失效
 * @param {number} data.uploadDateStart 上传开始日期，Asia/Shanghai 当天零点的毫秒时间戳，包含边界
 * @param {number} data.uploadDateEnd 上传结束日期，Asia/Shanghai 当天零点的毫秒时间戳，包含边界
 * @returns {blob: Blob, filename: string}
 */
export async function downloadQrcode(url, data) {
  return parseFileResponse(
    await axios(url, {
      baseURL: "/bluetoothlight/web/router/download/neewerhome/manage/",
      method: "POST",
      data,
      headers: {
        accessToken: localStorage.getItem("accessToken"),
      },
      timeout: 60_000,
      responseType: "blob", // 声明预期响应数据为 Blob 二进制对象
    })
  );
}

export function deviceListApi() {
  return request("/matter/models", {
    baseURL,
  });
}

/**
 * @typedef {Object} QrCodeItem
 * @property {string} [qrCode] 二维码编号
 * @property {string} [authCode] 认证码
 * @property {string} [discriminator] 鉴别器
 * @property {string} [checkCode] 校验码
 * @property {string} [firmwareUrl] 固件地址
 * @property {string} [imageUrl] 二维码图片地址
 */
/**
 * 上传二维码数据
 * @param {Object} data
 * @param {string} data.modelName 型号名称
 * @param {string} data.deviceModel 设备型号
 * @param {QrCodeItem[]} data.items 非空的 Matter 二维码数据列表
 * @returns
 */
export function uploadQrcode(data) {
  return request("/matter/upload", {
    baseURL,
    method: "post",
    data,
  });
}
/**
 * @typedef {Object} QrCodeListResponse
 * @property {number} totalNum 总条数
 * @property {QrCodeItem[]} items 二维码列表数据
 */
/**
 * 解压压缩包获取对应的 json 数据
 * @param {Object} data
 * @param {file} data.file matter压缩文件
 * @param {string} data.deviceModel 设备型号
 * @returns { Promise<QrCodeListResponse> }
 */
export function zip2Json(data) {
  return request("/bluetoothlight/web/matter/import", {
    method: "post",
    data,
  });
}
